// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__2s6ay"};